module.exports = __webpack_public_path__ + "static/img/hzq0417.1e61cb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hzq0417.jpg
// module id = Hg4n
// module chunks = 0